// Client-side region gate (Andreas, 2026-09-18).
//
// buy-buttons.liquid's server-rendered `region_supported` check can't see a
// visitor's real detected country — confirmed live that `localization.country`
// stays on the shop's default Market for any visitor with no existing
// selection, regardless of where they actually are (a fresh Spain-based
// request still rendered as Germany). Shopify does expose real geo-detection,
// but only via this JSON endpoint, meant to be read client-side:
// `/browsing_context_suggestions.json` — confirmed live it correctly
// resolves `detected_values.country.handle` to "ES" for a real Spain
// request even though the server-rendered page didn't reflect it.
//
// This is a UX hint, not a checkout-level enforcement — it runs after the
// page's first paint, so the button is briefly enabled before this disables
// it. Fine for "let the shopper know it's not available here", not a
// substitute for real server-side/checkout-level restriction if that's ever
// needed.
//
// Keep KNOWN_MARKET_CODES in sync with buy-buttons.liquid's own
// `region_supported` check and katadyn-pimcore-sync's
// src/17-marketVisibility.js (REGION_CODE_TO_MARKET_CODE) — launch is
// DE/CH/FR only, US intentionally excluded for now.
(function () {
  if (window.__regionAvailabilityChecked) return;
  window.__regionAvailabilityChecked = true;

  var KNOWN_MARKET_CODES = ['DE', 'FR', 'CH'];

  function gateForm(form) {
    var submitButton = form.querySelector('[type="submit"]');
    var message = form.querySelector('[data-region-availability-message]');
    if (submitButton) {
      submitButton.setAttribute('disabled', 'disabled');
      // Match the server-rendered disabled look (button-appearance.liquid)
      var appearance = submitButton.querySelector('.kt-button');
      var label = submitButton.querySelector('.kt-button__content');
      if (appearance) appearance.classList.add('kt-button--disabled');
      if (label && window.variantStrings) label.textContent = window.variantStrings.unavailable;
    }
    if (message) message.hidden = false;
  }

  function checkRegionAvailability() {
    fetch('/browsing_context_suggestions.json')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var detectedCode = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!detectedCode || KNOWN_MARKET_CODES.indexOf(detectedCode) !== -1) return;

        // Hides card quick add via CSS (component-card-product.css), so cards
        // injected later (e.g. product recommendations) are covered too.
        document.documentElement.classList.add('region-unavailable');
        document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(gateForm);
      })
      .catch(function () {
        // Fail open — never block a purchase over a detection error.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkRegionAvailability);
  } else {
    checkRegionAvailability();
  }
})();
